export interface ManifestationCard {
  id: string;
  text: string;
  imageUrl: string;
}

export const manifestationCards: ManifestationCard[] = [
  {
    id: 'manifest-1',
    text: 'The universe conspires to help those who dare to dream big',
    imageUrl: 'https://images.pexels.com/photos/3560044/pexels-photo-3560044.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-2',
    text: 'Your thoughts become things - choose the good ones',
    imageUrl: 'https://images.pexels.com/photos/1428277/pexels-photo-1428277.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-3',
    text: 'Success begins with believing you deserve extraordinary things',
    imageUrl: 'https://images.pexels.com/photos/3075993/pexels-photo-3075993.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-4',
    text: 'What you seek is seeking you - trust the process',
    imageUrl: 'https://images.pexels.com/photos/816608/pexels-photo-816608.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-5',
    text: 'Miracles happen when you align your actions with your highest vision',
    imageUrl: 'https://images.pexels.com/photos/1252890/pexels-photo-1252890.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-6',
    text: 'Your vibe attracts your tribe radiate positivity',
    imageUrl: 'https://images.pexels.com/photos/1367192/pexels-photo-1367192.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-7',
    text: 'The key to having everything is believing you already do',
    imageUrl: 'https://images.pexels.com/photos/1624496/pexels-photo-1624496.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-8',
    text: 'Every setback is a setup for an incredible comeback',
    imageUrl: 'https://images.pexels.com/photos/1738434/pexels-photo-1738434.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-9',
    text: 'You are exactly where you need to be to get where you want to go',
    imageUrl: 'https://images.pexels.com/photos/1765033/pexels-photo-1765033.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-10',
    text: 'Abundance flows to those who appreciate what they already have',
    imageUrl: 'https://images.pexels.com/photos/1907785/pexels-photo-1907785.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-11',
    text: 'Your only limit is the story you tell yourself',
    imageUrl: 'https://images.pexels.com/photos/1925738/pexels-photo-1925738.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-12',
    text: 'The magic you seek lives within your willingness to believe',
    imageUrl: 'https://images.pexels.com/photos/1766604/pexels-photo-1766604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-13',
    text: 'Fear is just excitement without breath - breathe and leap',
    imageUrl: 'https://images.pexels.com/photos/1769340/pexels-photo-1769340.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-14',
    text: 'When you change your inner world, your outer world transforms',
    imageUrl: 'https://images.pexels.com/photos/1907784/pexels-photo-1907784.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-15',
    text: 'Gratitude turns what you have into more than enough',
    imageUrl: 'https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-16',
    text: 'Your dreams are valid and waiting for you to claim them',
    imageUrl: 'https://images.pexels.com/photos/1766838/pexels-photo-1766838.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-17',
    text: 'Trust your journey even when the path is unclear',
    imageUrl: 'https://images.pexels.com/photos/3358707/pexels-photo-3358707.png?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-18',
    text: 'You are not just attracting a life - you are creating a masterpiece',
    imageUrl: 'https://images.pexels.com/photos/1428277/pexels-photo-1428277.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-19',
    text: 'The energy you put out today shapes your tomorrow',
    imageUrl: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-20',
    text: 'Your potential is infinite when you stop limiting yourself',
    imageUrl: 'https://images.pexels.com/photos/1529881/pexels-photo-1529881.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-21',
    text: 'Visualize with intention, act with purpose, receive with grace',
    imageUrl: 'https://images.pexels.com/photos/1906658/pexels-photo-1906658.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-22',
    text: 'Your soul knows the way - trust its whispers',
    imageUrl: 'https://images.pexels.com/photos/2240771/pexels-photo-2240771.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-23',
    text: 'Every moment is a fresh chance to redirect your destiny',
    imageUrl: 'https://images.pexels.com/photos/1420709/pexels-photo-1420709.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-24',
    text: 'You were born to shine - let nothing dim your light',
    imageUrl: 'https://images.pexels.com/photos/1236701/pexels-photo-1236701.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  },
  {
    id: 'manifest-25',
    text: 'Believe in the beauty of your dreams and they will believe in you',
    imageUrl: 'https://images.pexels.com/photos/1051838/pexels-photo-1051838.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
  }
];